export default __webpack_public_path__ + "static/media/calendar.5033f4e6.svg";